// extracted by mini-css-extract-plugin
module.exports = {"container":"practiceHeader_container__Aw_ai","img":"practiceHeader_img__2WOC1","overlay":"practiceHeader_overlay__2Ee2Q","spinner":"practiceHeader_spinner__2bA8Z"};